<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <g clip-path="url(#clip0_3900_37467)">
      <path
        d="M8.49967 5.99992C8.49967 5.72378 8.27582 5.49992 7.99967 5.49992C7.72353 5.49992 7.49967 5.72378 7.49967 5.99992L7.49967 7.49994H5.99967C5.72353 7.49994 5.49967 7.72379 5.49967 7.99994C5.49967 8.27608 5.72353 8.49994 5.99967 8.49994H7.49967V9.99992C7.49967 10.2761 7.72353 10.4999 7.99967 10.4999C8.27582 10.4999 8.49967 10.2761 8.49967 9.99992L8.49967 8.49994H9.99967C10.2758 8.49994 10.4997 8.27608 10.4997 7.99994C10.4997 7.72379 10.2758 7.49994 9.99967 7.49994H8.49967V5.99992Z"
        fill="#454545"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M7.99967 0.833252C4.04163 0.833252 0.833008 4.04188 0.833008 7.99992C0.833008 11.958 4.04163 15.1666 7.99967 15.1666C11.9577 15.1666 15.1663 11.958 15.1663 7.99992C15.1663 4.04188 11.9577 0.833252 7.99967 0.833252ZM1.83301 7.99992C1.83301 4.59416 4.59392 1.83325 7.99967 1.83325C11.4054 1.83325 14.1663 4.59416 14.1663 7.99992C14.1663 11.4057 11.4054 14.1666 7.99967 14.1666C4.59392 14.1666 1.83301 11.4057 1.83301 7.99992Z"
        fill="#454545"
      />
    </g>
    <defs>
      <clipPath id="clip0_3900_37467">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
